import * as Types from '../action/types';

let initialState = {
  shouldRefresh: false
};

export default function adminGroupManagementReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case Types.SEARCH_REFRESH:
      return {
        ...state,
        shouldRefresh: !state.shouldRefresh
      };

    default:
      return state;
  }
}
